import { createFileRoute } from '@tanstack/react-router';
import FeeEdit from '../../../features/baseData/fees/fee/edit';
import {
  createPermissionGuard,
  FEES_PERMISSIONS,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute(
  '/stammdaten/gebuehren/$feeId_/bearbeiten',
)({
  component: FeeEdit,
  beforeLoad: createPermissionGuard(getPermissionSet(FEES_PERMISSIONS, 'EDIT')),
});

export const EditFeeRoute = Route;
